const accordionContainers = document.querySelectorAll('[data-accordion-container]');

function triggerAccordion(accordion, action) {
    const accordionContent = accordion.querySelector('[data-accordion-content]');

    if (action === 'open') {
        accordionContent.classList.remove('hidden');
        accordionContent.classList.add('is-animating');

        accordion.classList.remove('closed');
        accordion.classList.add('opened');

        accordionContent.style.height = accordionContent.scrollHeight + 'px'
        accordionContent.style.opacity = '1'
    } else if (action === 'close') {
        accordion.classList.remove('opened');
        accordion.classList.add('closed');

        accordionContent.style.height = accordionContent.scrollHeight + 'px'
        accordionContent.style.opacity = '1'

        setTimeout(() => {
            accordionContent.style.height = '0px';
            accordionContent.style.opacity = '0';
        }, 200);
    }
}

accordionContainers.forEach(function (accordionContainer) {
    const accordions = accordionContainer.querySelectorAll('[data-accordion]');
    const toggleAll = accordionContainer.querySelector('[data-accordion-toggle-all]');

    let isTransitioning = false;
    let openAccordions = [];

    const isAcordionOpen = function (accordion) {
        return openAccordions.includes(accordion);
    };

    const isEveryAccordionOpen = function () {
        return openAccordions.length === accordions.length;
    };

    accordions.forEach(function (accordion) {
        const toggler = accordion.querySelector('[data-accordion-toggler]');
        const panel = accordion.querySelector('[data-accordion-content]');

        toggler.addEventListener('click', function () {
            if (isTransitioning) return;
            isTransitioning = true;

            if (!isAcordionOpen(accordion)) {
                triggerAccordion(accordion, 'open');
            } else {
                triggerAccordion(accordion, 'close');
            }
        });

        panel.addEventListener('transitionend', function (e) {
            if (e.propertyName !== 'height') return;
            isTransitioning = false;

            if (!isAcordionOpen(accordion)) {
                openAccordions.push(accordion);
                panel.classList.remove('is-animating');
            } else {
                openAccordions = openAccordions.filter(x => x !== accordion);

                panel.classList.add('hidden');
            }

            if (toggleAll !== null) {
                if (isEveryAccordionOpen()) {
                    toggleAll.classList.add('opened')
                    toggleAll.classList.remove('closed')
                } else {
                    toggleAll.classList.add('closed')
                    toggleAll.classList.remove('opened')
                }
            }

            toggler.toggleAttribute('aria-expanded');
            panel.toggleAttribute('aria-hidden');
            panel.setAttribute('style', '');
        });
    });

    if (toggleAll !== null) {
        toggleAll.addEventListener('click', function () {
            if (isTransitioning) return;
            isTransitioning = true;

            accordions.forEach(function (accordion) {
                if (!isEveryAccordionOpen() && !isAcordionOpen(accordion)) {
                    triggerAccordion(accordion, 'open');
                } else if (isEveryAccordionOpen() && isAcordionOpen(accordion)) {
                    triggerAccordion(accordion, 'close');
                }
            });
        });
    }

    window.addEventListener('beforeprint', function () {
        accordions.forEach(function (accordion) {
            if (!isEveryAccordionOpen() && !isAcordionOpen(accordion)) {
                triggerAccordion(accordion, 'open');
            }
        });
    });

    window.addEventListener('afterprint', function () {
        accordions.forEach(function (accordion) {
            if (isEveryAccordionOpen() && isAcordionOpen(accordion)) {
                triggerAccordion(accordion, 'close');
            }
        });
    });
});



